import { Button } from "@chakra-ui/react";
import React, { useState } from "react";
import {
  indoorHeptathlonEventListType,
  indoorHeptathlonEventType,
} from "../common/types";
import {
  IndoorcalcRecordByName,
  IndoorcalcScoreByName,
} from "./components/calcPoint";
import { eventNameDict } from "./components/eventNameDict";
import { HowToUse } from "./components/howToUse";
import { Links } from "./components/links";
import { ScoreInput } from "./components/scoreInput";

export const CalculatorIndoorHeptathlon = () => {
  const [records, setRecords] = useState<indoorHeptathlonEventListType>({
    b0: "",
    lj: "",
    sp: "",
    hj: "",
    b0h: "",
    pv: "",
    i000: "",
  });

  // 得点もinputでいじるのでこれも箱として良い
  const [points, setPoints] = useState<indoorHeptathlonEventListType>({
    b0: "",
    lj: "",
    sp: "",
    hj: "",
    b0h: "",
    pv: "",
    i000: "",
  });

  // 種目名を入れるとそれより前に行われたやつを全部足す関数
  const calcTotalPoint = (EventName: indoorHeptathlonEventType) => {
    let totalPoint = 0;
    for (const event in points) {
      const score = Number(points[event as indoorHeptathlonEventType]) || 0;
      totalPoint += score;
      if (event === EventName) {
        break;
      }
    }
    return totalPoint;
  };

  const handleChange =
    (key: indoorHeptathlonEventType) =>
    (score: React.ChangeEvent<HTMLInputElement>) => {
      const record = Number(score.target.value);
      setRecords({ ...records, [key]: record });
      const calucalatedPoint = IndoorcalcScoreByName(key, record);
      setPoints({ ...points, [key]: calucalatedPoint });
    };

  const handlePointChangeParent =
    (key: indoorHeptathlonEventType) =>
    (result: React.ChangeEvent<HTMLInputElement>) => {
      const point = Number(result.target.value);
      setPoints({ ...points, [key]: point });
      const score = IndoorcalcRecordByName(key, point);
      setRecords({ ...records, [key]: score });
    };

  const reset = () => {
    setPoints({
      b0: "",
      lj: "",
      sp: "",
      hj: "",
      b0h: "",
      pv: "",
      i000: "",
    });
    setRecords({
      b0: "",
      lj: "",
      sp: "",
      hj: "",
      b0h: "",
      pv: "",
      i000: "",
    });
  };
  const eventList = Object.keys(records) as indoorHeptathlonEventType[];

  return (
    <div>
      {/* <CustomHeader /> */}

      <div
        style={{ marginLeft: "100px", marginTop: "16px", marginBottom: "16px" }}
      >
        男子室内七種競技得点表
      </div>
      <div style={{ display: "flex", width: "360px", marginBottom: "10px" }}>
        <div style={{ marginLeft: "36px", width: "65%" }}>
          <HowToUse />
        </div>
        <Button
          onClick={reset}
          size="xs"
          style={{ color: "black", backgroundColor: "#f5f5f5" }}
        >
          Reset
        </Button>
      </div>
      {eventList.map((eN, index) => {
        const color = index % 2 === 0 ? "#f5f5f5" : "#ffffff";
        return (
          <div style={{ backgroundColor: color }} key={index}>
            <ScoreInput
              title={eventNameDict[eN]}
              record={records[eN]}
              point={points[eN]}
              handleScoreChange={handleChange(eN)}
              totalScore={calcTotalPoint(eN)}
              handlePointChange={handlePointChangeParent(eN)}
            />
          </div>
        );
      })}

      <div style={{ marginLeft: "16px" }}>---総合---</div>
      <div
        style={{
          display: "flex",
          width: "360px",
          textAlign: "center",
        }}
      >
        <div style={{ width: "30%", marginLeft: "10pt" }}>
          1日目：{calcTotalPoint("hj")}
        </div>
        <div style={{ width: "30%", marginLeft: "10pt" }}>
          2日目：{calcTotalPoint("i000") - calcTotalPoint("hj")}
        </div>
        <div style={{ width: "20%", textAlign: "right" }}>合計：</div>
        <div style={{ width: "20%", textAlign: "right", marginRight: "1pt" }}>
          {calcTotalPoint("i000")} 点
        </div>
      </div>
      <div style={{ marginTop: "10px", marginLeft: "270px" }}>
        <Button
          onClick={reset}
          size="xs"
          style={{ color: "black", backgroundColor: "#f5f5f5" }}
        >
          Reset
        </Button>
      </div>
      <Links />
    </div>
  );
};
